import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import storage from 'redux-persist/lib/storage';
import { all, fork } from 'redux-saga/effects';

import MainReducer, { MainSaga, MainState } from './main';
import UserReducer, { UserSaga, UserState } from './user';

const persistConfig = {
  key: 'user',
  storage: storage,
  whitelist: ['UserReducer'],
  transforms: [
    encryptTransform({
      secretKey: 'rescue-user-secret-key',
      onError: function (error) {
        // Handle the error.
      },
    }),
  ],
};

export function* RootSaga() {
  yield all([fork(MainSaga)]);
  yield all([fork(UserSaga)]);
}

const reducer = combineReducers({
  MainReducer,
  UserReducer,
});

export interface IStoreState {
  MainReducer: MainState;
  UserReducer: UserState;
}
export default persistReducer<any, any>(persistConfig, reducer);
